<!-- eslint-disable vue/html-self-closing -->
<template>
  <div
    v-if="discussions"
    class="w-100"
  >
    <TransitionGroup
      name="discussions-list"
      tag="div"
    >
      <div
        v-for="discussion in discussions"
        :key="discussion.id"
        class="mt-3 mb-1"
      >
        <div class="discussion__body d-flex">
          <div class="pr-3 d-none d-sm-block">
            <a :href="'/user/' + discussion.author.username">
              <img
                :src="discussion.author.avatar"
                class="rounded-circle"
                height="40px"
                width="40px"
              />
            </a>
          </div>
          <div class="d-flex flex-column w-100 min-width-0">
            <div class="d-flex flex-column">
              <div class="discussion-block-header mb-1">
                <a
                  class="text-dark"
                  :href="'/user/' + discussion.author.username"
                >
                  <span class="font-weight-bold">{{ discussion.author.fullName }}</span>
                  <span class="text-muted text-decoration-none">
                    @{{ discussion.author.username }}
                  </span>
                </a>
                <span class="text-muted">
                  {{ $t('discussion_created', { date: discussion.formatedDate }) }}
                </span>
              </div>
              <div
                v-if="discussion.lastUpdatedUser"
                class="mb-2"
              >
                <span class="text-muted">
                  {{ $t('answered_last') }}
                </span>
                <a
                  class="text-dark"
                  :href="'/user/' + discussion.lastUpdatedUser.username"
                >
                  <span class="font-weight-bold">
                    {{ discussion.lastUpdatedUser.fullName }}
                  </span>
                </a>
                <span class="text-muted">
                  {{ $moment.utc(discussion.updatedAt).fromNow() }}
                </span>
              </div>
            </div>

            <div
              class="card mb-3 mt-1 w-100"
              :class="{ 'stand-alone': !discussion.fileDiffId && !discussion.filePath }"
            >
              <div
                v-if="discussion.fileDiffId && discussion.filePath"
                class="card-header py-2"
              >
                <div class="d-flex align-items-center flex-grow-1">
                  <i class="gf-icon gf-icon-file mr-1" />
                  <div
                    v-if="
                      discussion.oldPath !== '/dev/null' &&
                      discussion.oldPath !== discussion.filePath
                    "
                    class="gf-text-direction-rtl text-truncate w-100"
                  >
                    <span class="gf-text-direction-ltr text-muted text-truncate ml-1">
                      {{ discussion.oldPath }}
                    </span>
                  </div>
                  <span
                    v-if="discussion.oldPath !== '/dev/null'"
                    class="mx-xl-4"
                  >
                    &#8594;
                  </span>
                  <div class="gf-text-direction-rtl text-truncate w-100">
                    <router-link
                      class="gf-text-direction-ltr"
                      tag="a"
                      :to="{
                        name: 'merge-request-item-diff',
                        hash: '#' + discussion?.fileDiffId
                      }"
                    >
                      {{ discussion.filePath }}
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="card-body break-word p-0">
                <div>
                  <table
                    class="table table-sm mb-0 table-borderless"
                    @copy.prevent="onCopy"
                  >
                    <commit-diff-item-line
                      v-for="line in discussion.highLightLines"
                      :key="line.id"
                      :line="line"
                    />
                  </table>
                  <div>
                    <div>
                      <div class="discussion-div">
                        <div class="discussion-holder">
                          <merge-request-discussion-reply
                            :reply="discussion"
                            @deleteDiscussion="onDiscussionDelete"
                          />
                          <TransitionGroup
                            name="test"
                            tag="div"
                          >
                            <merge-request-discussion-reply
                              v-for="reply in discussion.replies"
                              :key="reply.id"
                              :reply="reply"
                              @deleteDiscussion="onDiscussionReplyDelete"
                            />
                          </TransitionGroup>
                        </div>

                        <merge-request-discussion-reply-form
                          :discussion="discussion"
                          :auto-focus="true"
                          @closeDiscussion="closeDiscussion(discussion)"
                          @submitReply="onSubmitReply($event, discussion)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </TransitionGroup>
    <empty-listing
      v-if="!!discussions && !discussions.length"
      :title="$t('discussion_no')"
    />
  </div>
</template>

<script>
import helperS from '@shared/services/helper.service';
import MRService from '@shared/services/merge-request.service';

import CommitDiffItemLine from '@shared/shared-components/commit-diff/commit-diff-item-line';
import { EventBus, EventEnums } from '@shared/event-bus';
import EmptyListing from '@shared/shared-components/empty-listing';
import mergeRequestMessages from '@shared/modules/merge-request/mergeRequestMessages';
import GfCustomTooltip from '@shared/shared-components/shared/GfCustomTooltip';
// eslint-disable-next-line import/no-unresolved
import MergeRequestDiscussionReplyForm from './merge-request-discussion-reply-form';
// eslint-disable-next-line import/no-unresolved
import MergeRequestDiscussionReply from './merge-request-discussion-reply';
import ACTION_ENUM from '@shared/modules/custom-roles/custom-roles.constants';
import referenceService from '@shared/services/reference.service';

export default {
  name: 'MergeRequestItemDiscussions',
  components: {
    CommitDiffItemLine,
    MergeRequestDiscussionReplyForm,
    MergeRequestDiscussionReply,
    EmptyListing,
    GfCustomTooltip
  },
  props: ['discussions'],
  computed: {
    ACTION_ENUM() {
      return ACTION_ENUM;
    },
    mergeRequest() {
      return this.$store.getters.getSelectedMergeRequest;
    }
  },
  mounted() {},
  methods: {
    closeDiscussion(discussion) {
      MRService.resolveDiscussion(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.$route.params.id,
        discussion
      ).then(() => {
        MRService.getMergeRequestsItem(
          this.$route.params.alias,
          this.$route.params.projectAlias,
          this.$route.params.id
        );
      });
    },
    onSubmitReply(data, discussion) {
      MRService.createDiscussion(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        helperS.generateDiscussionObject(
          {
            data,
            discussion,
            file: { newPath: discussion.filePath, oldPath: discussion.oldPath },
            line: { id: discussion.lineDiffId }
          },
          this.mergeRequest
        )
      ).then(() => {
        EventBus.$emit(EventEnums.MERGE_REQUEST_DISCUSSION_REPLY_CREATED);
        MRService.getMergeRequestsItem(
          this.$route.params.alias,
          this.$route.params.projectAlias,
          this.$route.params.id
        );
      });
    },
    onCopy(e) {
      // e.clipboardData.setData('text/plain', helperS.copyCodeTransform(document.getSelection()));
      e.clipboardData.setData('text/plain', document.getSelection());
      e.preventDefault();
    },
    onDiscussionDelete(data) {
      this.$store.dispatch('deleteMergeRequestDiscussionById', data?.id);
      MRService.getMergeRequestsItem(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.$route.params.id
      );
    },
    onDiscussionReplyDelete(data) {
      this.$store.dispatch('deleteMergeRequestDiscussionReplyById', data?.id);
    }
  },
  i18n: {
    messages: mergeRequestMessages
  }
};
</script>

<style lang="scss">
.card.stand-alone .discussion-holder > .border-top:first-child {
  border-top: none !important;
}
.card img {
  width: 90%;
}
.gf-text-direction-rtl {
  direction: rtl;
}
.gf-text-direction-tlr {
  direction: tlr;
}

.discussions-list-enter-from,
.discussions-list-leave-to {
  animation: gf-hide-discussion 0.25s ease-in-out;
}

.test-enter-from,
.test-leave-to {
  animation: gf-hide-discussion 0.25s ease-in-out;
}

@keyframes gf-hide-discussion {
  0% {
    max-height: 2000px;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 0;
    max-height: 0;
  }
}
</style>
